// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_U4I","cls2":"AccountMenuButton-cls2_Pmx AccountMenuButton-cls1_U4I"};